<template>
  <div class="dashboard">
      <!--Programme-->
    <div class="card">
      <div class="card-header">
          Programme
          <!-- <span class="datetime" v-if="programme">
              {{ formattedDate }}
          </span>  -->
      </div>
      <div class="card-body">
          <a v-if="programme" :href="programme.url" target="_blank">View Current Programme</a>
      </div>
    </div>

    <!--Announcements -->
    <div class="card">
      <div class="card-header">
          Announcements
          <span class="datetime" v-if="announcements.length > 0">
              {{ announcements[0].datetime }}
          </span> 
      </div>
      <div class="card-body">
        <div class="anmts" v-for="(item, index) in announcements" v-bind:key="index">
          <h5 class="card-title">{{ item.title }}</h5>
          <p class="card-text" v-html="item.details"></p>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAnnouncements, getProgramme } from "../db";
import ntdm from 'number-to-date-month-name';

export default {
  name: "Dashboard",
  data() {
    return {
      announcements: [],
      programme: null
    };
  },
  computed: {
      formattedDate() {
          if (this.programme) {
              const dateString = this.programme.version.toString();
              return `${ntdm.toMonth(dateString.slice(4,6))} ${parseInt(dateString.slice(6,8))}, ${dateString.slice(0,4)}`;
          }
          return '';
      }
  },
  created() {
     this.getDashboardData();
  },
  methods: {
    async getAnmts() {
      const result = await getAnnouncements();
      const search = new RegExp(/[\n\r]/g);
      this.announcements = result.val().map(a => {
        return { ...a, details: a.details.replace(search, "<br/>") };
      });
    },
    async getPrgm() {
        const result = await getProgramme();
        this.programme = result.val();
    },
    async getDashboardData() {
      this.getAnmts();
      this.getPrgm();
    }
  }
};
</script>
<style lang="scss" scoped>
    .datetime {
        float: right;
    }
    .card {
        margin: 10px 0;
    }
</style>